export type GetCompanyLeaderboardPositionResponse = {
  items: MyLeaderboardPosition;
};

export type GetCompanyLeaderboardPositionRequest = {
  companyId: string;
  month: string;
};

export type MyLeaderboardPosition = {
  companyId: string;
  userId: string;
  month: string;
  points: number;
  position: number;
};

export type GetCompanyLeaderboardResponse = {
  items: LeaderboardElement[];
};

export type GetCompanyLeaderboardRequest = {
  companyId: string;
  month: string;
};

export interface GetChallengeRequest {
  companyId: string;
  datetime: string;
}

export interface GetChallengeResponse {
  item: Challenge;
}

export interface GetHistoryChallengesRequest {
  companyId: string;
}

export interface GetChallengesResponse {
  items: Challenge[];
}

export interface GetAchievementsRequest {
  companyId: string;
}

export interface GetAchievementsResponse {
  items: Achievement[];
}

export type LeaderboardElement = {
  companyId: string;
  updatedAt: string;
  userId: string;
  points: number;
  createdAt: string;
  user: {
    username: string;
  };
  sk: string;
  yearMonth: string;
  pk: string;
};

export interface Challenge {
  endsAt: string;
  targets: ChallengePrize[];
  companyId: string;
  startsAt: string;
  targetAmount: number;
  currentAmount: number;
  id: string;
}

export enum Medal {
  Gold = '/gold.png',
  Silver = '/silver.png',
  Bronze = '/bronze.png',
}

export interface ChallengePrize {
  icon: Medal;
  prizeQta: number;
  minPercent: number;
  type: string;
  prizeId: string;
  labels: Labels;
  prize: Prize;
}

export interface Labels {
  it: string;
}

export interface Prize {
  image: string;
  labels: Labels;
  metrics: Metrics;
  id: string;
  name: string;
  type: string;
}

export interface Metrics {
  [key: string]: Metric;
}

export interface Metric {
  amount: number;
  unit: string;
  labels: Labels;
}

export interface Achievement {
  totAmount: number;
  companyId: string;
  updatedAt: string;
  prizeId: string;
  createdAt: string;
  metrics: Metrics;
  prize: Prize;
}

export interface BadgeGained {
  __typename: string;
  count: number;
  companyId: string;
  badge: Badge;
  badgeId: string;
  updatedAt: string;
  userId: string;
  createdAt: string;
  sk: string;
  pk: string;
}

export interface Badge {
  name: BadgeType;
  progression: ProgressionEntity[];
  createdAt: string;
  id: string;
  updatedAt: string;
}

export interface ProgressionEntity {
  minProgress: number;
  image: string;
}

export enum BadgeType {
  Tree = 'Treemmy',
}
